module.exports = __webpack_public_path__ + "static/media/image-banner-1.ca1842ad.png";